import React from 'react';
import { cn } from '../../utils/lib/utils';

/**
 * @typedef {Object} ProgressBarProps
 * @property {*} value
 * @property {*} max?
 * @property {*} color?
 * @property {*} size?
 * @property {*} showValue?
 * @property {*} className?
 */

export const ProgressBar = React.forwardRef(({
  value,
  max = 100,
  color = 'purple',
  size = 'md',
  showValue = false,
  className = '',
  ...props
}, ref) => {
  const percentage = Math.min(100, (value / max) * 100);
  
  const sizeClasses = {
    sm: 'h-1',
    md: 'h-2',
    lg: 'h-3'
  };

  const colorClasses = {
    purple: 'bg-purple-600',
    blue: 'bg-blue-600',
    green: 'bg-green-600',
    red: 'bg-red-600'
  };

  return (
    <div
      ref={ref}
      className={cn(
        'w-full bg-gray-200 rounded-full overflow-hidden',
        sizeClasses[size],
        className
      )}
      {...props}
    >
      <div
        className={cn(
          'h-full transition-all duration-300 ease-in-out',
          colorClasses[color]
        )}
        style={{ width: `${percentage}%` }}
      />
      {showValue && (
        <div className="absolute right-0 top-0 -mt-6 text-sm text-neutral-400">
          {Math.round(percentage)}%
        </div>
      )}
    </div>
  );
});
